export const GET_TIMETABLES_REQUEST = "GET_TIMETABLES_REQUEST";
export const GET_TIMETABLES_SUCCESS = "GET_TIMETABLES_SUCCESS";
export const GET_TIMETABLES_FAIL = "GET_TIMETABLES_FAIL";

export const GET_TIMETABLES_CATEGORY_REQUEST =
  "GET_TIMETABLES_CATEGORY_REQUEST";
export const GET_TIMETABLES_CATEGORY_SUCCESS =
  "GET_TIMETABLES_CATEGORY_SUCCESS";
export const GET_TIMETABLES_CATEGORY_FAIL = "GET_TIMETABLES_CATEGORY_FAIL";
